import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import Routes from "./Routes";
import {Auth} from 'aws-amplify';
import './components/Nav.css'
import Typekit from 'react-typekit';
import ReactGA from 'react-ga';
import {logoutUser} from "./store/ReduxStore";
import './App.css';
import { ToastContainer } from "react-toastify";
import NewSidebar from "./containers/sidebar/NewSidebar"

import {authorize,loginUser,idleUser} from "./actions/AuthActions";
import {connect} from "react-redux";
import config from "./config";

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
const mql = window.matchMedia(`(min-width: 800px)`);

ReactGA.initialize('UA-5477132-6');
ReactGA.pageview('/');

/*mapping current users basic information and permissions to Redux*/
const mapStateToProps = state => {
    return { user: state.authState };
};
/*retrieving current users basic information and permissions from Redux*/
const mapDispatchToProps = dispatch => {
    return {
        authorize : () => dispatch(authorize()),
        loginUser : (email) => dispatch(loginUser(email)),
        idleUser : () => dispatch(idleUser())
    };
};

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            isAuthenticating: true,
            pageType: "",
            sidebarOpen: true,
            sidebarDocked: true,
            awsCreds : null,
            open : false,
            isMobile:false,
            noOfTasks:0,
            user:{},
            timeoutID:0
        };
        this.props.history.listen(location => {
                ReactGA.pageview(location.pathname)
            }
        );
    }

    async componentDidMount(){
        // listening for changes in screen change
        mql.addListener(this.mediaQueryChanged);
        this.setState({ isMobile:!mql.matches});
        try{
            let poolData = {
                UserPoolId: config.cognito.USER_POOL_ID, // Your user pool id here
                ClientId: config.cognito.APP_CLIENT_ID, // Your client id here
            };
            let userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
            let cognitoUser = userPool.getCurrentUser();
            let parent = this;
            if (cognitoUser != null) {
                cognitoUser.getSession(function(err, session) {
                    if (err) {
                        alert(err.message || JSON.stringify(err));
                        return;
                    }
                    // NOTE: getSession must be called to authenticate user before calling getUserAttributes
                    cognitoUser.getUserAttributes(function(err, attributes) {
                        if (err) {
                            // Handle error
                        } else {
                            // Do something with attributes
                        }
                    });
                    parent.setState({user: session});
                    parent.props.loginUser(true);
                    parent.userHasAuthenticated(session);
                });
            }
        }catch (e) {
            console.log(e);
        }
        try {
            await Auth.currentUserCredentials().then(
                credentials => {
                    this.setState({awsCreds: credentials});
                    this.setState({isAuthenticating: false})
                }
            );
        }catch (e) {
            this.setState({isAuthenticating: false})
        }
    }
    componentWillUnmount() {
        // listening for changes in screen change
        mql.removeListener(this.mediaQueryChanged);
    }

    mediaQueryChanged  = () => {
        this.setState({ isMobile:!mql.matches});
    };

    onSetOpen = (open) => {
        this.setState({ open: open });
        if(!open){
            this.setState({sidebarDocked:true})
        }
        else{
            this.setState({sidebarDocked:false})
        }
    };

    userHasAuthenticated = (session) =>{
        this.props.authorize();
        this.setState({ isAuthenticated: true });
    };

    loggedIn = async () =>{
        let user =await  Auth.currentAuthenticatedUser();
        if(user.attributes.email_verified){
            console.log('email verified');
            this.props.loginUser();
        }else{
            console.log('not verified')
            this.props.loginUser(false);
        }

        this.setState({ isAuthenticated: true });
    };

    // can not be async,
    handleLogout = async () => {
            await Auth.signOut();
            this.setState({ isAuthenticated: false });
            logoutUser();
            this.props.history.push("/login");
    };

    openMenu =(e) =>{
        this.setState({sidebarDocked:!e,open:e})
    };

    handleNoOfTasks = (tasks) =>{
        if(tasks){
            this.setState({noOfTasks:tasks});
        }
    };

    // getTasks = username => {
    //     return API.get("users", `users/user/tasks/${username}`);
    // };
    //
    // createNotification(user,type,message){
    //     console.log("in function before");
    //     let payload={"type":type,"message":message};
    //     API.post("users","functions/mqtt/send",{
    //         body:{username:user,payload:payload}
    //     }).then(response=>{
    //         console.log(response)
    //     });
    //     console.log("in function after");
    // }

    render() {
        let className;
        /*add navbar classes for style depending whether it is mobile or full screen docked*/
        if(this.state.sidebarDocked && this.state.isMobile){
            className = "custom-sidebar-class sidebar-closed"
        }else{
            className = "custom-sidebar-class"
        }

        /* props to send through to all routes */
        const childProps = {
            user: this.props.user,
            isAuthenticated: this.state.isAuthenticated,
            loggedIn:this.loggedIn
        };
        return (

            !this.state.isAuthenticating &&
            <div className={"App"}>
                <Typekit kitId="dhl2fte" />
                {this.props.user.status === "LOGGED_IN" && this.props.user.role !==null && this.props.user.cognitoInfo !==null  ?
                        <div className="app-wrapper logged=in">
                            <div id="sidebar">
                              <NewSidebar handleLogout = {this.handleLogout}/>
                            </div>
                            <div id={"App"}>
                                <Routes childProps={childProps} />
                                <ToastContainer  />
                            </div>
                        </div>
                    : this.props.user.status === "LOGGED_OUT" ?
                    <Fragment>
                    <Routes childProps={childProps} />
                    </Fragment>
                        : <p>Loading...</p>
                }
                {/*<Splash />*/}
            </div>
        );
    }
}
const AppPage = connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(AppPage);

